import { createAction, props } from '@ngrx/store';
import { PaginatedNotificationListResponseList, Notification } from 'libs/mona/api/src/lib/model';
import { Encounter } from '@mona/models';
import { AsyncAction, FailedAction, SucceededAction } from '@mona/store';

/**
 * Notifications actions
 */
export class NotificationsAction {
    /**
     * Init notifications subscription
     */
    static initNotificationSub = createAction('NOTIFICATIONS:INIT_NOTIFICATIONS_SUB');

    /**
     * Load pageable notifications action
     */
    static loadPageableNotificationsAction = createAction(
        'NOTIFICATIONS:LOAD_PAGEABLE_NOTIFICATIONS',
        props<{
            url?: string;
            isLoadMore?: boolean;
            readStatus?: boolean;
            encounterId?: EntityId<Encounter>;
        }>(),
    );

    static loadPageableNotificationsActionSuccess = createAction(
        'NOTIFICATIONS:LOAD_PAGEABLE_NOTIFICATIONS_SUCCESS',
        props<{
            payload: PaginatedNotificationListResponseList.Model;
            readStatus?: boolean;
            isLoadMore?: boolean;
        }>(),
    );

    static loadPageableNotificationsActionFailed = createAction(
        'NOTIFICATIONS:LOAD_PAGEABLE_NOTIFICATIONS_FAILED',
        props<FailedAction>(),
    );

    static loadPageableNotificationsActionCancelled = createAction(
        'NOTIFICATIONS:LOAD_PAGEABLE_NOTIFICATIONS_CANCELLED',
        props<{ reason: string }>(),
    );

    /**
     * Clear paginated notifications action
     */
    static clearPaginatedNotificationsAction = createAction('NOTIFICATIONS:CLEAR_PAGINATED_NOTIFICATIONS');

    /**
     * Change paged notification read status action
     */
    static changePagedNotificationReadStatusAction = createAction(
        'NOTIFICATIONS:CHANGE_PAGED_NOTIFICATION_READ_STATUS',
        props<{ notification: Notification.Model; readStatus: boolean }>(),
    );

    static changePagedNotificationReadStatusActionSuccess = createAction(
        'NOTIFICATIONS:CHANGE_PAGED_NOTIFICATION_READ_STATUS_SUCCESS',
        props<{ notification: Notification.Model; readStatus: boolean }>(),
    );

    static markMultipleNotificationsAsReadActionSuccess = createAction(
        'NOTIFICATIONS:MARK_MULTIPLE_NOTIFICATIONS_AS_READ_SUCCESS',
        props<{ notifications: Notification.Model[] }>(),
    );

    static markMultipleNotificationsAsReadAction = createAction(
        'NOTIFICATIONS:MARK_MULTIPLE_NOTIFICATIONS_AS_READ',
        props<{ notificationIds: string[] }>(),
    );

    static changeNotificationReadStatusAction = createAction(
        'NOTIFICATIONS:CHANGE_NOTIFICATION_READ_STATUS',
        props<{ notificationId: string; readStatus: boolean }>(),
    );

    static changeNotificationReadStatusActionSuccess = createAction(
        'NOTIFICATIONS:CHANGE_NOTIFICATION_READ_STATUS_SUCCESS',
        props<{ notification: Notification.Model }>(),
    );

    static changeNotificationReadStatusActionFailed = createAction(
        'NOTIFICATIONS:CHANGE_NOTIFICATION_READ_STATUS_FAILED',
        props<FailedAction>(),
    );

    /**
     * Load has-unread notifications action
     */
    static loadHasUnreadNotificationsAction: AsyncAction<
        {
            encounterId: EntityId<Encounter>;
        },
        { hasUnread: boolean }
    > = {
        action: createAction(
            'NOTIFICATIONS:LOAD_HAS_UNREAD_NOTIFICATIONS',
            props<{
                encounterId: EntityId<Encounter>;
            }>(),
        ),

        succeededAction: createAction(
            'NOTIFICATIONS:LOAD_HAS_UNREAD_NOTIFICATIONS_SUCCEEDED',
            props<SucceededAction<{ hasUnread: boolean }>>(),
        ),

        failedAction: createAction('NOTIFICATIONS:LOAD_HAS_UNREAD_NOTIFICATIONS_FAILED', props<FailedAction>()),

        clearAction: createAction('NOTIFICATIONS:LOAD_HAS_UNREAD_NOTIFICATIONS_CLEAR'),
    };

    /**
     * Add/update notification action
     */
    static addUpdateNotificationAction = createAction(
        'NOTIFICATIONS:ADD_UPDATE_NOTIFICATION',
        props<{ notification: Notification.Model }>(),
    );
}
